// <gallery-doors> — home gallery (prototype Categories.dc.html, docs/03).
// Desktop: hovering a door makes it the dark stage; the next door shows its media, the last its text.
// Until the first pointer entry an auto-tour previews the doors. The cursor bubble follows the pointer over
// the stage and morphs into a capsule / arrow button it passes over. Phone: accordion with a swipe strip.
const desk = window.matchMedia('(min-width: 1024px)');
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const DROP = [
  { transform: 'translateY(-90px)', opacity: 0, easing: 'cubic-bezier(.55,0,.85,.4)' },
  { transform: 'none', opacity: 1, offset: 0.5, easing: 'cubic-bezier(.25,.6,.35,1)' },
  { transform: 'translateY(6px)', offset: 0.68, easing: 'cubic-bezier(.45,0,.4,1)' },
  { transform: 'translateY(-2px)', offset: 0.85, easing: 'cubic-bezier(.45,0,.4,1)' },
  { transform: 'none' }
];
const BUMP = [{ transform: 'none' }, { transform: 'translateY(-6px)', offset: 0.4 }, { transform: 'translateY(2px)', offset: 0.75 }, { transform: 'none' }];

class GalleryDoors extends HTMLElement {
  connectedCallback() {
    this.D = JSON.parse(this.querySelector('[data-doors]').textContent);
    this.s = { active: null, topic: null, step: 0, swap: 0, txSwap: 0, prevSrc: '', prevTx: null };
    this.cats = this.querySelector('.cats'); this.cur = this.querySelector('.cat-cur');
    this.dwell = 3400;
    this.warm();

    // desktop
    this.querySelectorAll('.cat').forEach((c) => {
      const i = +c.dataset.door;
      c.addEventListener('mouseenter', () => desk.matches && this.activate(i));
      c.querySelector('.cat-t')?.addEventListener('focus', () => this.activate(i));
    });
    this.cats.addEventListener('mouseenter', () => { this.touched = true; clearTimeout(this.tourT); clearTimeout(this.leaveT); });
    this.cats.addEventListener('mouseleave', () => this.leave());
    this.cats.addEventListener('mousemove', (e) => this.cursor(e));
    this.cats.addEventListener('click', (e) => this.onClick(e));
    // phone
    this.querySelectorAll('.mc-head').forEach((h) => h.addEventListener('click', () => {
      const i = +h.closest('.mcat').dataset.door;
      if (this.s.active === i) this.set({ active: null, topic: null, step: 0, prevSrc: '', prevTx: null }); else this.activate(i);
    }));
    this.querySelector('.mcats').addEventListener('click', (e) => this.onClick(e));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.s.active !== null && this.contains(document.activeElement) && desk.matches) this.set({ active: null, topic: null, step: 0 }); });

    this.io = new IntersectionObserver((es) => es.forEach((en) => {
      if (!en.isIntersecting) return;
      this.classList.add('in'); this.io.disconnect(); this.startTour();
    }), { threshold: 0.18 });
    this.io.observe(this);
    desk.addEventListener('change', () => this.render(true));
    document.addEventListener('shopify:block:select', (e) => { const el = e.target.closest?.('.cat'); if (el && this.contains(el)) { this.touched = true; this.activate(+el.dataset.door); } });
    this.render(true);
  }

  // ---- state ----
  set(patch, txChange = true) {
    const prev = { ...this.s };
    const cur = this.current();
    Object.assign(this.s, { prevSrc: cur.src, swap: this.s.swap + 1 }, txChange ? { prevTx: cur.tx, txSwap: this.s.txSwap + 1 } : {}, patch);
    const full = prev.active !== this.s.active || prev.topic !== this.s.topic;
    this.render(full, txChange);
    if (full) this.schedule();
    if (prev.active !== this.s.active && !desk.matches && this.s.active !== null) {
      setTimeout(() => { const el = this.querySelector('.mcat.on'); if (el) window.scrollTo({ top: el.getBoundingClientRect().top + scrollY - 60, behavior: reduce.matches ? 'auto' : 'smooth' }); }, 80);
    }
  }
  activate(i) { clearTimeout(this.leaveT); if (this.s.active === i) return; this.set({ active: i, topic: null, step: 0 }); }
  leave() {
    this.cats.classList.remove('cur-on'); this.cur.classList.remove('on', 'snap');
    if (document.querySelector('.film:not([hidden])')) return;
    clearTimeout(this.leaveT);
    this.leaveT = setTimeout(() => this.set({ active: null, topic: null, step: 0, prevSrc: '', prevTx: null }), 700);
  }
  startTour() {
    if (!desk.matches || this.touched || reduce.matches) return;
    const seq = [0, 1, 2, null]; let k = 0;
    const step = () => {
      if (this.touched || document.querySelector('.film:not([hidden])')) return;
      const v = seq[k % seq.length]; k++;
      if (v === null) this.set({ active: null, topic: null, step: 0, prevSrc: '', prevTx: null }); else this.activate(v);
      this.tourT = setTimeout(step, v === null ? 6000 : this.dwell);
    };
    this.tourT = setTimeout(step, 1400);
  }

  // what the active door shows now
  steps() {
    const a = this.s.active; if (a === null) return { steps: [], gallery: false, kick: '' };
    const D = this.D[a]; const tp = this.s.topic !== null ? D.topics[this.s.topic] : null;
    const kick = D.title + (tp ? ' / ' + tp.label : '');
    if (tp) {
      const g = tp.gallery.filter(Boolean);
      return { gallery: g.length > 0, kick, steps: (g.length ? g : ['']).map((m) => ({ img: m, title: tp.title, body: tp.body, kicker: tp.kicker || kick })) };
    }
    const ov = D.ov; const g = ov.gallery.filter(Boolean);
    if (ov.video) return { gallery: false, kick, steps: [{ video: ov.video, poster: ov.poster, title: ov.title, body: ov.body, origin: ov.origin, kicker: kick }] };
    return { gallery: g.length > 1, kick, steps: (g.length ? g : [ov.poster]).map((m) => ({ img: m, title: ov.title, body: ov.body, origin: ov.origin, kicker: kick })) };
  }
  current() {
    const { steps } = this.steps(); const st = steps[Math.min(this.s.step, Math.max(0, steps.length - 1))] || {};
    return { src: st.video ? st.poster : (st.img || ''), tx: st.title ? { kicker: st.kicker, title: st.title, body: st.body, origin: st.origin || '' } : null };
  }

  // Preload + decode every door image/poster once, so a swap never paints an undecoded <img> (white flash).
  warm() {
    const urls = new Set();
    const walk = (o) => { if (typeof o === 'string') { if (/^(https?:)?\/\/|^\//.test(o) && /\.(jpe?g|png|webp|avif)(\?|$)/i.test(o)) urls.add(o); } else if (o && typeof o === 'object') Object.values(o).forEach(walk); };
    walk(this.D);
    this._warm = [...urls].map((u) => { const im = new Image(); im.src = u; im.decode?.().catch(() => {}); return im; });
  }

  // ---- render ----
  render(full = true, txChange = true) {
    const a = this.s.active; const { steps, gallery } = this.steps();
    const n = steps.length; const k = Math.min(this.s.step, Math.max(0, n - 1));
    const par = this.s.swap % 2 ? 'sa' : 'sb'; const tpar = this.s.txSwap % 2 ? 'sa' : 'sb';
    const others = a === null ? [] : [0, 1, 2].filter((i) => i !== a && i < this.D.length);
    const role = (i) => (a === null ? 'idle' : i === a ? 'stage' : i === others[0] ? 'media' : 'text');
    const media = (cls) => steps.map((st, j) => `<div class="mi2${j === k ? ' on ' + par : ''}">${st.video
      ? `<video src="${esc(st.video)}" poster="${esc(st.poster)}" muted loop playsinline aria-hidden="true"${reduce.matches ? '' : ' autoplay'}></video>`
      : st.img ? `<img src="${esc(st.img)}" alt="">` : ''}</div>`).join('');
    const tx = (st, cls) => st ? `<div class="${cls}"><div class="tx-k">${esc(st.kicker)}</div><h3><span class="tx-l"><span>${esc(st.title)}</span></span></h3><p>${esc(st.body)}</p>${st.origin ? `<div class="tx-o">${esc(st.origin)}</div>` : ''}</div>` : '';
    const prevTx = this.s.prevTx ? tx(this.s.prevTx, 'tx txo ' + tpar).replace('<div class="tx txo', '<div aria-hidden="true" class="tx txo') : '';
    const curTx = tx(steps[gallery ? 0 : k], 'tx on ' + tpar);
    const AD = a !== null ? this.D[a] : null;

    if (desk.matches) {
      this.cats.classList.toggle('is-open', a !== null);
      this.querySelectorAll('.cat').forEach((c) => {
        const i = +c.dataset.door; const r = role(i); const slot = c.querySelector('.cat-slot');
        const was = c.dataset.role; c.dataset.role = r;
        c.className = 'cat role-' + r;
        if (r === 'stage') {
          if (full || was !== r) {
            const pills = AD.topics.map((t, j) => `<button type="button" class="pill${this.s.topic === j ? ' on' : ''}${t.film ? ' is-film' : ''}" aria-pressed="${this.s.topic === j}" data-topic="${j}">${esc(t.label)}</button>`).join('');
            slot.innerHTML = `<a class="cat-hit" href="${esc(AD.curHref)}" tabindex="-1" aria-label="${esc(AD.cur.replace(/\n/g, ' '))}"></a>
              <div class="stage-sub"><div class="pills row" role="group" aria-label="${esc(AD.title)}">${pills}</div>
              <div class="stage-top">${n > 1 ? `<div class="stage-nav"><span data-count>${k + 1} / ${n}</span><button type="button" class="sq" data-step="-1" aria-label="Previous"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M10 3L5 8l5 5"/></svg></button><button type="button" class="sq" data-step="1" aria-label="Next"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M6 3l5 5-5 5"/></svg></button></div>` : ''}</div></div>`;
          } else { const c2 = slot.querySelector('[data-count]'); if (c2) c2.textContent = `${k + 1} / ${n}`; }
        } else if (r === 'media') {
          slot.innerHTML = `<div class="media-stack${was === 'media' ? ' keep' : ''}"><div class="mi-prev">${this.s.prevSrc ? `<img src="${esc(this.s.prevSrc)}" alt="">` : ''}</div>${media()}</div><span class="media-cap">${n > 1 ? `${k + 1} / ${n}` : ''}</span>`;
        } else if (r === 'text') {
          if (full || txChange || was !== r) slot.innerHTML = `<div class="tx-stack" aria-live="polite">${prevTx}${curTx}</div><div class="tx-foot"><span class="small">${n > 1 && !gallery ? `Step ${k + 1} of ${n}` : ''}</span></div>`;
        } else slot.innerHTML = '';
      });
      const cl = this.cur.querySelector('.cat-cur-l'); if (cl) cl.textContent = AD ? AD.cur : '';
    } else {
      this.querySelectorAll('.mcat').forEach((m) => {
        const i = +m.dataset.door; const on = i === a; const slot = m.querySelector('.mc-slot');
        m.classList.toggle('on', on); m.querySelector('.mc-head').setAttribute('aria-expanded', String(on));
        if (!on) { slot.innerHTML = ''; return; }
        if (full || !slot.firstChild) {
          const slides = steps.map((st) => `<div class="mc-slide">${st.video ? `<video src="${esc(st.video)}" poster="${esc(st.poster)}" muted loop playsinline aria-hidden="true"${reduce.matches ? '' : ' autoplay'}></video>` : st.img ? `<img src="${esc(st.img)}" alt="" decoding="async">` : ''}</div>`).join('');
          const pills = AD.topics.map((t, j) => `<button type="button" class="mpill${this.s.topic === j ? ' on' : ''}${t.film ? ' is-film' : ''}" aria-pressed="${this.s.topic === j}" data-topic="${j}">${esc(t.label)}</button>`).join('');
          slot.innerHTML = `<div class="mc-body"><div class="mc-track">${slides}</div>
            ${n > 1 ? `<div class="mc-prog" role="group" aria-label="Steps">${steps.map((_, j) => `<button type="button" class="seg${j === k ? ' on' : j < k ? ' done' : ''}" aria-label="Step ${j + 1}" data-go="${j}"><i></i></button>`).join('')}</div>` : ''}
            ${pills ? `<div class="mc-pills" role="group" aria-label="${esc(AD.title)}">${pills}</div>` : ''}
            <div class="mc-tx" aria-live="polite">${prevTx}${curTx}</div>
            ${AD.href ? `<a href="${esc(AD.href)}" class="mc-cta"><span>${esc(AD.cta)}</span><span aria-hidden="true">→</span></a>` : ''}</div>`;
          const tr = slot.querySelector('.mc-track');
          tr.addEventListener('scroll', () => { clearTimeout(this.msT); this.msT = setTimeout(() => { const j = Math.round(tr.scrollLeft / tr.clientWidth); if (j !== this.s.step && j >= 0 && j < n) { this.fromSwipe = true; this.set({ step: j }, !gallery); } }, 90); }, { passive: true });
        } else {
          slot.querySelectorAll('.mc-prog .seg').forEach((g, j) => { g.className = 'seg' + (j === k ? ' on' : j < k ? ' done' : ''); });
          if (txChange) { const box = slot.querySelector('.mc-tx'); if (box) box.innerHTML = prevTx + curTx; }
          const tr = slot.querySelector('.mc-track');
          if (tr && !this.fromSwipe) tr.scrollTo({ left: k * tr.clientWidth, behavior: reduce.matches ? 'auto' : 'smooth' });
        }
        this.fromSwipe = false;
      });
    }
    // gallery steps advance on their own
    clearTimeout(this.gT);
    if (gallery && a !== null && n > 1 && !reduce.matches) this.gT = setTimeout(() => this.set({ step: (k + 1) % n }, false), 4200);
  }

  // capsules drop in after a door opens
  schedule() {
    clearTimeout(this.dropT); this.anims?.forEach((x) => x.cancel());
    if (this.s.active === null || reduce.matches) return;
    this.dropT = setTimeout(() => {
      const els = [...this.querySelectorAll(desk.matches ? '.cat.role-stage .pills .pill' : '.mcat.on .mpill')];
      this.anims = els.map((el, i) => el.animate?.(DROP, { duration: 900, delay: i * 70, fill: 'backwards' })).filter(Boolean);
    }, 360);
  }

  onClick(e) {
    const p = e.target.closest('[data-topic]');
    if (p) {
      const D = this.D[this.s.active]; const j = +p.dataset.topic; const t = D.topics[j];
      if (t.film) { document.dispatchEvent(new CustomEvent('film:open', { detail: { ...t.film, trigger: p } })); return; }
      this.set({ topic: this.s.topic === j ? null : j, step: 0 });
      const np = this.querySelector(`${desk.matches ? '.cat.role-stage .pill' : '.mcat.on .mpill'}[data-topic="${j}"]`); np?.animate?.(BUMP, { duration: 600, easing: 'cubic-bezier(.45,0,.4,1)' });
      return;
    }
    const st = e.target.closest('.stage-nav [data-step]');
    if (st) { const { steps, gallery } = this.steps(); const n = steps.length; this.set({ step: (this.s.step + +st.dataset.step + n) % n }, !gallery); return; }
    const g = e.target.closest('.mc-prog [data-go]');
    if (g) { const { gallery } = this.steps(); this.set({ step: +g.dataset.go }, !gallery); }
  }

  cursor(e) {
    if (!desk.matches) return;
    const r = this.cats.getBoundingClientRect(); const t = e.target;
    const over = t.closest?.('.cat.role-stage');
    const ctl = t.closest?.('button, a:not(.cat-hit), .pill, .stage-nav');
    const live = !!over && this.s.active !== null && !document.querySelector('.film:not([hidden])');
    const pill = live && ctl && ctl.closest('.stage-sub') ? (ctl.closest('.pill, .sq') || null) : null;
    const show = live && (!ctl || !!pill);
    const el = this.cur;
    if (pill) {
      const b = pill.getBoundingClientRect(); const cx = b.left + b.width / 2 - r.left, cy = b.top + b.height / 2 - r.top;
      el.style.setProperty('--sw', b.width + 'px'); el.style.setProperty('--sh', b.height + 'px');
      el.style.setProperty('--sr', getComputedStyle(pill).borderTopLeftRadius || '999px');
      el.style.transform = `translate(${cx + (e.clientX - r.left - cx) * 0.12}px,${cy + (e.clientY - r.top - cy) * 0.12}px)`;
    } else el.style.transform = `translate(${e.clientX - r.left}px,${e.clientY - r.top}px)`;
    el.classList.toggle('snap', !!pill); el.classList.toggle('on', show); this.cats.classList.toggle('cur-on', show);
  }
}
if (!customElements.get('gallery-doors')) customElements.define('gallery-doors', GalleryDoors);
